(function() {
  var AutocompleteEditor, BetterAutocompleteEditor, hot;

  hot = window.Handsontable;

  AutocompleteEditor = hot.editors.AutocompleteEditor;

  BetterAutocompleteEditor = AutocompleteEditor.prototype.extend();

  BetterAutocompleteEditor.prototype.open = function() {
    var choicesListHot, that;
    that = this;
    hot.editors.HandsontableEditor.prototype.open.apply(this, arguments);
    this.TEXTAREA.style.visibility = 'visible';
    this.focus();
    this.htContainer.style.overflow = 'hidden';
    choicesListHot = this.htEditor.getInstance();
    choicesListHot.updateSettings({
      colWidths: [Handsontable.Dom.outerWidth(this.TEXTAREA) - 2],
      afterRenderer: function(TD, row, col, prop, value) {
        var caseSensitive, indexOfMatch, match;
        caseSensitive = this.getCellMeta(row, col).filteringCaseSensitive === true;
        if (value) {
          if (caseSensitive) {
            indexOfMatch = value.indexOf(this.query);
          } else {
            indexOfMatch = value.toLowerCase().indexOf(that.query.toLowerCase());
          }
          if (indexOfMatch !== -1) {
            match = value.substr(indexOfMatch, that.query.length);
            return TD.innerHTML = value.replace(match, '<strong>' + match + '</strong>');
          }
        }
      }
    });
    return that.instance._registerTimeout(setTimeout(function() {
      that.queryChoices('');
      return that.htContainer.style.overflow = 'auto';
    }));
  };

  BetterAutocompleteEditor.prototype.updateChoicesList = function(choices) {
    var endPos, filteringCaseSensitive, highlightIndex, i, j, len, orderByRelevance, sorted;
    filteringCaseSensitive = this.cellProperties.filteringCaseSensitive === true;
    orderByRelevance = AutocompleteEditor.sortByRelevance(this.query, choices, filteringCaseSensitive);
    if (this.cellProperties.filter !== false) {
      sorted = [];
      for (j = 0, len = orderByRelevance.length; j < len; j++) {
        i = orderByRelevance[j];
        sorted.push(choices[i]);
      }
      highlightIndex = 0;
      choices = sorted;
    } else {
      highlightIndex = orderByRelevance[0];
    }
    this.choices = choices;
    this.htEditor.loadData(Handsontable.helper.pivot([choices]));
    this.htEditor.updateSettings({
      height: this.getDropdownHeight()
    });
    if (this.cellProperties.strict === true) {
      this.highlightBestMatchingChoice(highlightIndex);
    }
    this.instance.listen();
    this.TEXTAREA.focus();
    if (this.query === '') {
      endPos = this.getValue().length;
      return Handsontable.Dom.setCaretPosition(this.TEXTAREA, 0, (endPos !== 0 ? endPos : void 0));
    }
  };

  hot.editors.registerEditor('betterAutocomplete', BetterAutocompleteEditor);

}).call(this);
